import { render } from "./MandatoryList.vue?vue&type=template&id=a4ac4222"
import script from "./MandatoryList.vue?vue&type=script&lang=ts"
export * from "./MandatoryList.vue?vue&type=script&lang=ts"

import "./MandatoryList.vue?vue&type=style&index=0&id=a4ac4222&lang=scss"
script.render = render

export default script